import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../index';
import { CommodityService } from '../../data/commodity.service';
import {
    commodityEditorLoadComplete,
    commodityEditorLoadFailure,
    commodityEditorLoadRequest, commodityEditorNew, commodityEditorSaveFailure,
    commodityEditorSaveRequest, commodityEditorSaveSuccess
} from './commodity-editor.actions';
import { catchError, filter, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { selectCommodityEditorState } from './commodity-editor.state';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { commodityTableRequest } from '../commodity-table/commodity-table.actions';
import { CommodityEditComponent } from '../../modules/package-library/commodity-edit/commodity-edit.component';

@Injectable()
export class CommodityEditorEffects {

    constructor(private actions$: Actions, private store: Store<AppState>, private commodityService: CommodityService,
                private snackbar: MatSnackBar, private dialog: MatDialog) {
    }

    commodityEditorLoad$ = createEffect(() => this.actions$.pipe(
        ofType(commodityEditorLoadRequest),
        switchMap((action) => this.commodityService.getByKey(action.id).pipe(
            map((commodity) => commodityEditorLoadComplete({ commodity })),
            catchError(() => of(commodityEditorLoadFailure()))
        ))
    ));

    commodityEditorLoadFailure$ = createEffect(() => this.actions$.pipe(
        ofType(commodityEditorLoadFailure),
        tap(() => this.snackbar.open($localize`We are having difficulty communicating with the server.  Please try again later.`)),
        tap(() => this.dialog.closeAll())
    ), { dispatch: false });

    commodityEditorUpdate$ = createEffect(() => this.actions$.pipe(
        ofType(commodityEditorSaveRequest),
        withLatestFrom(this.store.select(selectCommodityEditorState)),
        filter(([ , state ]) => state.id !== null),
        switchMap(([ , state ]) => this.commodityService.update(state.commodity).pipe(
            map(() => commodityEditorSaveSuccess()),
            catchError(() => of(commodityEditorSaveFailure()))
        ))
    ));

    commodityEditorCreate$ = createEffect(() => this.actions$.pipe(
        ofType(commodityEditorSaveRequest),
        withLatestFrom(this.store.select(selectCommodityEditorState)),
        filter(([ , state ]) => state.id === null),
        switchMap(([ , state ]) => this.commodityService.add(state.commodity).pipe(
            map(() => commodityEditorSaveSuccess()),
            catchError(() => of(commodityEditorSaveFailure()))
        ))
    ));

    commodityEditorSaveSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(commodityEditorSaveSuccess),
        tap(() => this.dialog.closeAll()),
        tap(() => this.snackbar.open($localize`Commodity saved successfully`)),
        map(() => commodityTableRequest())
    ));

    commodityEditorSaveFailure$ = createEffect(() => this.actions$.pipe(
        ofType(commodityEditorSaveFailure),
        tap(() => this.snackbar.open($localize`Unable to save changes to this commodity.  Please try again.`))
    ), { dispatch: false });

    commodityEditorNew$ = createEffect(() => this.actions$.pipe(
        ofType(commodityEditorNew),
        tap(() => this.dialog.open(CommodityEditComponent))
    ), { dispatch: false });

}
